import React, { useEffect } from "react";

export default function Explorer() {
  useEffect(() => {
    const NAVBAR_HEIGHT = 70;
    const handler = (e) => {
      if (e.data?.type !== "explorerMouseMove") return;
      window.dispatchEvent(
        new MouseEvent("mousemove", {
          clientX: e.data.x,
          clientY: e.data.y + NAVBAR_HEIGHT,
          bubbles: true,
        })
      );
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  return (
    <div style={{ position: "fixed", top: "70px", left: 0, right: 0, bottom: 0 }}>
      <iframe
        src="/explorer.html"
        title="Ego Blockchain Explorer"
        style={{ width: "100%", height: "100%", border: "none", display: "block" }}
      />
    </div>
  );
}
